import request from "@/utils/request";

//我的金主- 金主列表
export function owner_list(data) {
  return request({
    url: "/data/connection/connection_tabulation",
    method: "post",
    data
  });
}

// 我的金主---标签列表
export function label_list(data) {
  return request({
    url: "/data/connection/label_tabulation",
    method: "post",
    data
  });
}

// 我的金主---添加标签
export function add_label(data) {
  return request({
    url: "/data/connection/add_label",
    method: "post",
    data
  });
}

// 我的金主---添加批注
export function add_remark(data) {
  return request({
    url: "/data/connection/add_connectionremark",
    method: "post",
    data
  });
}

// 我的金主---转化合作
export function transformation_cooperation(data) {
  return request({
    url: "/data/connection/transformation_cooperation",
    method: "post",
    data
  });
}

// 我的金主--录入金主信息
export function add_connection(data) {
  return request({
    url: "/data/connection/add_connection",
    method: "post",
    data
  });
}

// 我的金主--录入需求
export function add_demand(data) {
  return request({
    url: "/data/connection/add_demand",
    method: "post",
    data
  });
}

// 我的金主--编辑金主信息
export function edit_connection(data) {
  return request({
    url: "/data/connection/edit_connection",
    method: "post",
    data
  });
}

//我的金主- 骗子库
export function pz_connection_tabulation(data) {
  return request({
    url: "/data/connection/pz_connection_tabulation",
    method: "post",
    data
  });
}

// 金主-任务中心
export function task_list(data) {
  return request({
    url: "/data/taskcenter/task_tabulation",
    method: "post",
    data
  });
}

// 任务中心-访问记录
export function access_records(data) {
  return request({
    url: "/data/taskcenter/access_records",
    method: "post",
    data
  });
}

//任务中心- 选择写手
export function recipient_list(data) {
  return request({
    url: "/data/taskcenter/recipient_list",
    method: "post",
    data
  });
}

//任务中心- 确认合作
export function confirm_cooperation(data) {
  return request({
    url: "/data/taskcenter/confirm_cooperation",
    method: "post",
    data
  });
}

//任务中心- 查看投稿列表
export function submission_download_list(data) {
  return request({
    url: "/data/taskcenter/submission_download_list",
    method: "post",
    data
  });
}

//任务中心- 驳回
export function submission_reject(data) {
  return request({
    url: "/data/taskcenter/submission_reject",
    method: "post",
    data
  });
}

//任务中心- 查看投稿-全部下载
export function submission_download(data) {
  return request({
    url: "/data/taskcenter/submission_download",
    method: "post",
    data
  });
}

//任务中心- 编辑任务中心
export function edit_demand(data) {
  return request({
    url: "/data/connection/edit_demand",
    method: "post",
    data
  });
}

// 金主书籍信息--登记列表
export function connectionessay_list(data) {
  return request({
    url: "/data/taskcenter/connectionessay_list",
    method: "post",
    data
  });
}

// 金主书籍信息--确认完结
export function confirm_completion(data) {
  return request({
    url: "/data/taskcenter/confirm_completion",
    method: "post",
    data
  });
}

// 金主书籍信息--修改书籍信息
export function edit_connectionessay(data) {
  return request({
    url: "/data/taskcenter/edit_connectionessay",
    method: "post",
    data
  });
}

// 金主书籍信息--停止合作
export function cease_cooperate(data) {
  return request({
    url: "/data/taskcenter/cease_cooperate",
    method: "post",
    data
  });
}

// 金主书籍信息--每日上传记录
export function connectionrecord_list(data) {
  return request({
    url: "/data/taskcenter/connectionrecord_list",
    method: "post",
    data
  });
}

// 金主书籍信息--下载文件
export function connectionrecord_zip(data) {
  return request({
    url: "/data/taskcenter/connectionrecord_zip",
    method: "post",
    data
  });
}

// 金主书籍信息--选择写手
export function writer_list(data) {
  return request({
    url: "/data/writer/writer_list",
    method: "post",
    data
  });
}

// 金主公海信息--公海列表
export function connection_list(data) {
  return request({
    url: "/data/internationalwaters/connection_list",
    method: "post",
    data
  });
}

// 金主公海信息--历史备注
export function connectionremark_list(data) {
  return request({
    url: "/data/internationalwaters/connectionremark_list",
    method: "post",
    data
  });
}

// 金主公海信息--历史备注
export function change_connection(data) {
  return request({
    url: "/data/internationalwaters/change_connection",
    method: "post",
    data
  });
}

// 书籍下载文件--书籍列表
export function connectionessay_file_list(data) {
  return request({
    url: "/data/connection/connectionessay_file_list",
    method: "post",
    data
  });
}

// 书籍下载文件--上传记录
export function connectionessay_file_log(data) {
  return request({
    url: "/data/connection/connectionessay_file_log",
    method: "post",
    data
  });
}

// 下载周稿
export function c_week_list(data) {
  return request({
    url: "/data/uploadfile/c_week_list",
    method: "post",
    data
  });
}

// 下载周稿--批量下载
export function c_week_zip(data) {
  return request({
    url: "/data/uploadfile/c_week_zip",
    method: "post",
    data
  });
}

// 数据中心--我的考核
export function examine_list(data) {
  return request({
    url: "/data/connectiondatacenter/examine_list",
    method: "post",
    data
  });
}

// 数据中心--我的考核-上传图片
export function upload_connectpoints(data) {
  return request({
    url: "/data/connectiondatacenter/upload_connectpoints",
    method: "post",
    data
  });
}

// 我的数据--列表
export function information_list(data) {
  return request({
    url: "/data/connectiondatacenter/information_list",
    method: "post",
    data
  });
}

// 金主日结登记--列表
export function connectionrecord_day_list(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_day_list",
    method: "post",
    data
  });
}

// 金主日结登记--修改备注
export function connectionrecord_qd_remark(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_qd_remark",
    method: "post",
    data
  });
}

// 金主日结登记--驳回
export function connectionrecord_day_reject(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_day_reject",
    method: "post",
    data
  });
}

// 金主日结登记--通过
export function connectionrecord_day_endorse(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_day_endorse",
    method: "post",
    data
  });
}

// 金主日结登记--批量下载
export function connectionrecord_day_zip(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_day_zip",
    method: "post",
    data
  });
}

// 金主日结表--详情列表
export function connectionrecord_history_list(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_history_list",
    method: "post",
    data
  });
}

// 金主日结表--列表
export function connectionrecord_history_list_week(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_history_list_week",
    method: "post",
    data
  });
}

// 金主周结登记--列表
export function connectionrecord_week_list(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_week_list",
    method: "post",
    data
  });
}

// 金主周结登记--驳回
export function connectionrecord_week_reject(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_week_reject",
    method: "post",
    data
  });
}

// 金主周结登记--通过
export function connectionrecord_week_endorse(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_week_endorse",
    method: "post",
    data
  });
}

// 金主周结登记--下载
export function connectionrecord_week_zip(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_week_zip",
    method: "post",
    data
  });
}

// 金主周结表--列表
export function connectionrecord_history_week_list_week(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_history_week_list_week",
    method: "post",
    data
  });
}

// 金主周结表--详情列表
export function connectionrecord_history_week_list(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_history_week_list",
    method: "post",
    data
  });
}

// 金主周结表--导出功能
export function connectionrecord_history_week_excel(data) {
  return request({
    url: "/data/connectiondatacenter/connectionrecord_history_week_excel",
    // responseType: "blob",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/utils/owner.js